const ROOT_CATEGORY = 73375816;

export {
    ROOT_CATEGORY
};
